import { useEffect, useRef } from 'react';

export function useScrollReveal<T extends HTMLElement>(options?: { threshold?: number; rootMargin?: string; root?: Element | null }) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
          observer.unobserve(el);
        }
      },
      { threshold: 0.01, rootMargin: '0px 0px 0px 0px', ...options }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return ref;
}
